export const LANDING = '/';
export const LIBRARY = '/library';
export const SHARE = '/sh';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const SETTINGS = '/settings';
export const DELIVERY = '/delivery';